export default __webpack_public_path__ + "static/media/criminal2.70dff0e0.jpg";